module.exports = __webpack_public_path__ + "img/interpackmaxi_dfod_k.61d589b0.png";